export { default } from './brands-list.component';
